import useFetchApi, { isLoading } from 'hooks/useFetchApi/useFetchApi'
import countryService from 'Services/api/country.service'

const useFetchCountries = () => {
    const [countries = [], fetchCountries, status] = useFetchApi(
        countryService.getCountries,
    )

    return [countries, isLoading(status), fetchCountries] as const
}

export default useFetchCountries
